<script lang="ts">
</script>

<header class="topBar">
  <span class="topBar__logo">HTML_Commentify</span>
</header>

<style>
  .topBar {
    width: 100%;
    padding: 1em 2em;
    background-color: var(--color-primary);
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  }

  .topBar__logo {
    color: var(--color-white);
    font-weight: bold;
  }
</style>
